import { lazy, Suspense, type ReactNode } from 'react'

const PrivyRoot = lazy(() => import('./privy-root'))

interface Props {
  children: ReactNode
}

/** Mounts the Privy SDK, a lazy chunk (`app/privy-root.tsx`), around the app. */
export const AuthProvider = ({ children }: Props) => (
  <Suspense fallback={null}>
    <PrivyRoot>{children}</PrivyRoot>
  </Suspense>
)
